import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { isDarkTheme } from "segments/segments-service";
import PictureComponent from "/components/core/picture/picture-component";
import classnames from "classnames";
import Toggle from "components/core/toggle";
import DefaultProps from "./default-props";
import { LIGHT_WORK_OS_IRIS_COLOR_NAME, WORK_OS_IRIS_COLOR_NAME, BACKGROUND_GRAY_COLOR_NAME } from "styles/color-consts";
import Colors from "styles/colors";
import Title from "segments/desktop/core-components/title/title";
import Paragraph from "segments/desktop/core-components/paragraph/paragraph";
import WM_LOGOS from "constants/work-managment-logos";
import LinesSvgComponent from "./lines-svg-component";
import PathsAndCirclesSvgComponent from "./paths-and-circles-svg-component";
import { ICONS_ARRAY, LOGO_DATA } from "./consts";
import { StyledMondayIntegrationsConnectionsComponent } from "./monday-integrations-connections-component.scss";
const MondayIntegrationsConnectionsComponent = (props)=>{
    const { theme, componentTitle, beforeAnimationSubTitle, afterAnimationSubTitle, switchRightPhrase, switchLeftPhrase } = props;
    const [animationIsOn, setAnimationState] = useState(false);
    const switchbackground = isDarkTheme(theme) ? Colors[BACKGROUND_GRAY_COLOR_NAME] : Colors[LIGHT_WORK_OS_IRIS_COLOR_NAME];
    const switchTextsColors = !isDarkTheme(theme);
    const changeAnimationState = ()=>{
        setAnimationState(!animationIsOn);
    };
    const renderIcons = ()=>{
        return ICONS_ARRAY.map((icon)=>/*#__PURE__*/ _jsx("div", {
                className: "icon",
                style: {
                    "--x-before": `${icon.startLocation[0]}px`,
                    "--y-before": `${icon.startLocation[1]}px`,
                    "--x-after": `${icon.endLocation[0]}px`,
                    "--y-after": `${icon.endLocation[1]}px`
                },
                children: /*#__PURE__*/ _jsx(PictureComponent, {
                    src: icon.iconImage
                })
            }, `${icon.startLocation[0]}_${icon.startLocation[1]}_${icon.endLocation[0]}_${icon.endLocation[1]}}`));
    };
    return /*#__PURE__*/ _jsx(StyledMondayIntegrationsConnectionsComponent, {
        className: "monday-integrations-connections-component",
        children: /*#__PURE__*/ _jsxs("div", {
            className: classnames("monday-integrations-wrapper", {
                animation: animationIsOn
            }),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "title-wrapper",
                    children: /*#__PURE__*/ _jsx(Title, {
                        title: componentTitle
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "toggle-wrapper",
                    children: /*#__PURE__*/ _jsx(Toggle, {
                        handleToggle: changeAnimationState,
                        leftPhrase: switchLeftPhrase,
                        rightPhrase: switchRightPhrase,
                        toggleBackgroundColor: switchbackground,
                        toggleButtonColor: Colors[WORK_OS_IRIS_COLOR_NAME],
                        swtichTextsColors: switchTextsColors,
                        isOn: animationIsOn
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "icons-and-lines-wrapper",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "monday-logo",
                            style: {
                                "--left": `${LOGO_DATA.xLocation}px`,
                                "--top": `${LOGO_DATA.yLocation}px`
                            },
                            children: /*#__PURE__*/ _jsx(PictureComponent, {
                                src: WM_LOGOS.WM_INTEGRATION_LOGO
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            classNames: "SVGs-container",
                            children: [
                                renderIcons(),
                                /*#__PURE__*/ _jsx(LinesSvgComponent, {
                                    theme: theme
                                }),
                                /*#__PURE__*/ _jsx(PathsAndCirclesSvgComponent, {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "before-animation-paragraph-wrapper",
                    children: /*#__PURE__*/ _jsx(Paragraph, {
                        body: beforeAnimationSubTitle
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "after-animation-paragraph-wrapper",
                    children: /*#__PURE__*/ _jsx(Paragraph, {
                        body: afterAnimationSubTitle
                    })
                })
            ]
        })
    });
};
MondayIntegrationsConnectionsComponent.defaultProps = DefaultProps;
export default MondayIntegrationsConnectionsComponent;
